import React from 'react';
import { formatDateRange, formatAssignmentDateSpan } from '../../../../../utils/dateUtils';
import { getInitials } from '../../../../../utils/resourceUtils';

const ConflictResourceGroup = ({
    group,
    isExpanded,
    onToggle,
    onEditAssignment,
    onEditResource,
    formatReason
}) => {
    const gid = `${group.type}-${group.id}`;
    
    // Original helper to match visuals exactly as in git history
    const getAvatarColor = (name) => {
        const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f43f5e', '#f59e0b', '#10b981', '#06b6d4'];
        let hash = 0;
        for (let i = 0; i < (name?.length || 0); i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
        return colors[Math.abs(hash) % colors.length];
    };

    return (
        <div className="co-resource-group">
            <div className="co-resource-card">
                <div className="co-resource-header" onClick={() => onToggle(gid)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', cursor: 'pointer' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div className="co-avatar" style={{ width: 40, height: 40, background: getAvatarColor(group.name), display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px', color: 'white', fontWeight: 700 }}>
                            {getInitials(group.name)}
                        </div>
                        <div className="co-resource-info">
                            <h3 style={{ margin: 0, fontSize: '0.95rem', fontWeight: 700 }}>{group.name} <span className="co-res-role" style={{ fontWeight: 400, color: '#64748b' }}>| {group.role}</span></h3>
                            <div className="co-resource-type" style={{ fontSize: '0.65rem', color: '#64748b', textTransform: 'uppercase' }}>
                                {group.type === 'worker' ? 'Mitarbeiter' : (group.type === 'vehicle' ? 'Fahrzeug' : 'Kolonne')} · {group.items.length} Konflikt(e)
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="co-conflict-count-badge">
                            {group.items.length} ⚠️
                        </span>
                        <span style={{ marginLeft: 12, transform: isExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', fontSize: '0.8rem' }}>
                            ▼
                        </span>
                    </div>
                </div>

                {isExpanded && (
                    <div className="co-conflict-list" style={{ borderTop: '1px solid #f1f5f9', background: '#fafafa' }}>
                        <div style={{ padding: '12px' }}>
                            {group.items.map((item, idx) => {
                                const capReason = formatReason(item.reason);
                                return (
                                    <div key={idx} className="co-conflict-item" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', background: 'white', border: '1px solid #f1f5f9', borderRadius: '8px', marginBottom: '6px' }}>
                                        <div className="co-date-pill" style={{ minWidth: '90px', fontWeight: 700, color: '#d97706', fontSize: '0.8rem' }}>
                                            {item.date?.split('-').reverse().join('.') || 'Datum fehlt'}
                                        </div>

                                        <div className="co-project-tiles" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4, padding: '0 12px', borderLeft: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9' }}>
                                            {(item.assignments || [item.assignment]).map((a, aIdx) => (
                                                <div 
                                                    key={aIdx}
                                                    className="co-mini-tile"
                                                    onClick={() => onEditAssignment && onEditAssignment(a)}
                                                    style={{ background: '#eff6ff', border: '1px solid #dbeafe', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer' }}
                                                >
                                                    <span className="co-tile-name" style={{ fontSize: '0.75rem', fontWeight: 700, color: '#1e40af' }}>{a.projektname || a.project_name || 'Unbenannt'}</span>
                                                    <span className="co-tile-time" style={{ fontSize: '0.65rem', color: '#3b82f6' }}>
                                                        {formatAssignmentDateSpan(a)}
                                                    </span>
                                                </div>
                                            ))}
                                            {/* Redundant absence tile removed as requested */}
                                        </div>

                                        <div 
                                            className="co-reason-area" 
                                            style={{ minWidth: '140px', textAlign: 'right', cursor: item.absence ? 'pointer' : 'default' }}
                                            onClick={() => item.absence && onEditResource && onEditResource(item.resourceId, item.type, { action: 'absences', absenceId: item.absence.id })}
                                        >
                                            <div className="co-reason-text" style={{ fontSize: '0.75rem', fontWeight: 700, color: '#e11d48', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 4 }}>
                                                <span>⚠️</span> {capReason}
                                            </div>
                                            <div className="co-reason-details" style={{ fontSize: '0.7rem', color: '#64748b', marginTop: 2 }}>{item.details || (item.assignments?.length > 1 ? 'Überschneidung' : 'Belegungskonflikt')}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConflictResourceGroup;
